import React, { FC } from 'react';
import styles from './entities_card_body.module.scss';
import { Hyperlink } from '../Hyperlink';

type Props = {
  href: string;
  source: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  target?: '_blank';
};

export const EntitiesCardBodyLink: FC<Props> = ({
  href,
  source,
  onClick,
  target,
  children,
}) => (
  <div className={styles.linkcontainer}>
    <Hyperlink href={href} source={source} onClick={onClick} target={target}>
      {children}
    </Hyperlink>
  </div>
);
